export function isSuperAdmin(user) {
  return Boolean(user?.is_superuser);
}

export function getLoggedInOrganisation(user) {
  const organisation = user?.profile?.organisation;
  if (!organisation?.organisation_id) {
    return null;
  }
  return {
    organisation_id: organisation.organisation_id,
    name: organisation.name || '',
  };
}

/**
 * Returns true when targetUser is the same account as loggedInUser.
 */
export function isSameUser(loggedInUser, targetUser) {
  if (!loggedInUser || !targetUser) {
    return false;
  }

  if (loggedInUser.id != null && targetUser.id != null) {
    return String(loggedInUser.id) === String(targetUser.id);
  }

  if (loggedInUser.username && targetUser.username) {
    return loggedInUser.username === targetUser.username;
  }

  return false;
}
